import { Box, Container, Link, Typography } from "@material-ui/core";
import WorldIcon from "../images/bx_world.png";
import LocationIcon from "../images/carbon_location-filled.png";
import MobIcon from "../images/bi_phone-fill.png";
import EmIcon from "../images/carbon_email.png";
import FBIcon from "../images/fa-brands_facebook-square.png";

export const Footer = () => (
  <footer class="footer bg-dark">
    <div class="container" style={{display:'none'}}>
      <a href="#" class="footer__logo logo _anim-items _fadeScale" data-animate-delay="01">
        <img src="/img/logo-footer.png" alt="" />
      </a>
    </div>
    <div class="footer__clip">
      <div class="container footer__container">
        <div
          class="footer_item footer__text  _anim-items _fadeLeft rubik weight-500 f-16"
          style={{ color: "white" }}
          data-animate-delay="02">
        <a href="#" class=" logo _anim-items _fadeScale" data-animate-delay="01">
        <img src="/img/foot-logo.png" alt="" />
      </a>
         <p className="mt-20"> ‘World Of Tzedaka’, formerly ’Tomchei Tzedaka Corp’, changed its name as per the guidance
          of Lakewood’s Posek, Rabbi Yaakov Forchheimer shlit”a, to avoid confusion with
          similarly-named organizations.
          </p>
        </div>
        <div
          style={{ color: "white", paddingLeft: 35 }}
          class="footer_item1 footer__contacts  _anim-items _fadeRight"
          data-animate-delay="02"
        >
          Tomchei Tzedaka corp. DBA <br/> World Of Tzedaka has 501(c) <br/> 3 accreditation, Tax ID <br/> 81-4838703
        </div>
        <div className="footer_item2">
          <p className="rubik weight-500 f-28 color-1 mb-0">Contact Us</p>
          <div className="_anim-items _fadeRight flex" data-animate-delay="04">
            <div className="contacts-wrap__icon" style={{marginBottom: '0px'}}>
              <img src={LocationIcon} alt="" />
            </div>
            <div
              className="contacts-wrap__text text-white weight-400 f-normal roboto f-16"
              style={{ marginTop: 10, marginLeft: 10 }}
            >
              <span className="weight-500">Address:</span>
              16 Bridgewood Ave,<br/> Lakewood NJ 08701
            </div>
          </div>
          <div className="_anim-items _fadeRight flex" data-animate-delay="05">
            <div className="contacts-wrap__icon" style={{marginBottom: '0px'}}>
              <img src={MobIcon} alt="" />
            </div>
            <div
              className="contacts-wrap__text text-white weight-400 f-normal roboto f-16"
              style={{ marginTop: 10, marginLeft: 10, fontSize: "14px" }}
            >
              <span className="weight-500">Call or Text: </span>
              732-307-8182 <br />
              <span className="weight-500">WhatsApp:</span> Click here
            </div>
          </div>
          <div className="_anim-items _fadeRight flex" data-animate-delay="06">
            <div className="contacts-wrap__icon" style={{marginBottom: '0px'}}>
              <img src={EmIcon} alt="" />
            </div>
            <div
              className="contacts-wrap__text text-white weight-400 f-normal roboto f-16"
              style={{ marginTop: 10, marginLeft: 10, fontSize: "14px" }}
            >
              <span className="weight-500">Email:</span>
              info@tomcheitzedaka.org
            </div>
          </div>
          <div className="_anim-items _fadeRight flex" data-animate-delay="06">
            <div className="contacts-wrap__icon" style={{marginBottom: '0px'}}>
              <img src={FBIcon} alt="" />
            </div>
            <div
              className="contacts-wrap__text text-white weight-400 f-normal roboto f-16"
              style={{ marginTop: 10, marginLeft: 10, fontSize: "14px" }}
            >
              <span className="weight-400 rubik f-16">world of tzedakah {'>>'}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer__bottom ">
      <div class="container">
        <div class="footer__btext">All rights reserved This site was built by sheltzer net</div>
      </div>
    </div>
  </footer>
);
